class TeacherActivity {
	id = null;
	teacher_id = null;
	planned_course_id = null;
	date = null;
	hours = null;
	description = '';
	billing = true;
	hour_rate_type = 'T1';
	hour_rate = null;
	// amount = null;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default TeacherActivity;
